import axios from 'axios';
import { v4 } from 'uuid';
import { configRefs } from '@utils/config';
import { transformComponentDataV1ToV2 } from './v1Adapter/componentData/transformComponentDataV1ToV2.js';
import '@i-ark/models';
import '@i-ark/utils';

const fetchComponentById = async (componentId) => {
  const response = await axios.get(
    `${await configRefs.apis.componentFramework.get()}/api/Components/Get/${encodeURIComponent(componentId)}`
  );
  const rawComponentData = typeof response.data.Content === "string" && response.data.Content.length > 0 ? JSON.parse(response.data.Content) : createEmptyComponent();
  const v2ComponentData = isComponentDataV1(rawComponentData) ? await transformComponentDataV1ToV2(rawComponentData) : rawComponentData;
  return {
    title: response.data.Title,
    type: response.data.Type,
    productId: response.data.Owner.ProductID,
    componentData: v2ComponentData
  };
};
function isComponentDataV1(componentData) {
  return !("version" in componentData) || componentData.version !== 2;
}
function createEmptyComponent() {
  return {
    version: 2,
    lastEditorVersion: 2,
    originalVersion: 2,
    settings: {
      enabledFeatures: {
        richTextFormating: true,
        wiris: false
      },
      crediting: "",
      speechLanguage: "da",
      latexSpeechLanguage: "none"
    },
    style: {
      colors: {
        textColor: "#000",
        inputTextColor: "#000"
      }
    },
    pages: [
      {
        id: v4(),
        title: "",
        aspectRatio: 0.6,
        naturalSize: {
          width: 900,
          height: 540
        },
        items: []
      }
    ]
  };
}

export { fetchComponentById, isComponentDataV1 };
//# sourceMappingURL=fetchComponentById.js.map
